import React, { useEffect, useMemo, type ReactNode } from 'react';
import { useRibbon } from '../../context/RibbonContext';
import { MasterRibbon } from '../MasterRibbon';
import type { RibbonConfig } from '../../types/ribbon';

interface ModuleLayoutProps {
  ribbon?: ReactNode | null;
  ribbonConfig?: RibbonConfig | null;
  headerMeta?: ReactNode | null;
  children: ReactNode;
  className?: string;
  contentClassName?: string;
}

export function ModuleLayout({
  ribbon,
  ribbonConfig,
  headerMeta,
  children,
  className = '',
  contentClassName = '',
}: ModuleLayoutProps) {
  const { setRibbonContent, setHeaderMetaContent } = useRibbon();

  const ribbonNode = useMemo(() => {
    if (ribbon) return ribbon;
    if (ribbonConfig) return <MasterRibbon config={ribbonConfig} />;
    return null;
  }, [ribbon, ribbonConfig]);

  useEffect(() => {
    setRibbonContent(ribbonNode);
  }, [ribbonNode, setRibbonContent]);

  useEffect(() => () => setRibbonContent(null), [setRibbonContent]);

  useEffect(() => {
    setHeaderMetaContent(headerMeta ?? null);
  }, [headerMeta, setHeaderMetaContent]);

  useEffect(() => () => setHeaderMetaContent(null), [setHeaderMetaContent]);

  return (
    <div className={`flex h-full min-h-0 flex-col overflow-hidden ${className}`.trim()}>
      <div className={`min-h-0 flex-1 ${contentClassName}`.trim()}>{children}</div>
    </div>
  );
}

export default ModuleLayout;
